import * as _ from "lodash";
import * as Redux from "redux";
import storage from "redux-persist/lib/storage";

import { FilterParams } from "src/core/shared/api";
import { NotificationActions } from "src/core/notifications/store/notifications.actions";
import * as AT from "src/core/notifications/store/notifications.constants";

import { INotification } from "../api/notifications.api";

export type NotificationFilterParams = FilterParams<Omit<INotification, "notificationReads">>;

export interface INotificationsData {
  count: number;
  pages: number;
  data: INotification[];
}
export interface INotificationsStore {
  showNotifications: {
    show: boolean;
    notificationId: number | null;
  };
  notification: INotification | null;
  unreadNotifications: number | null;
}

const initialState: INotificationsStore = {
  notification: null,
  showNotifications: {
    show: false,
    notificationId: null
  },
  unreadNotifications: null
};

export const notificationsReducer: Redux.Reducer<INotificationsStore> = (
  state: INotificationsStore = initialState,
  action: NotificationActions
): INotificationsStore => {
  switch (action.type) {
    case AT.SET_NOTIFICATION:
      return {
        ...state,
        notification: action.notification
      };

    case AT.SHOW_HIDE_NOTIFICATIONS:
      return {
        ...state,
        showNotifications: {
          show: action.show !== undefined ? action.show : !state.showNotifications,
          notificationId: action.notificationId || null
        }
      };

    case AT.PURGE_NOTIFICATIONS:
      return initialState;

    default:
      return state;
  }
};

// config for persisting within this reducer
export const notificationsPersistConfig = {
  key: "notifications",
  storage,
  blacklist: [ "" ]
};
